import styled, { css } from 'styled-components';
import ScrollbarSnippet from '../../../../../../css-snippets/ScrollbarSnippet';

export const Wrapper = styled.div`
  position: relative;
`;

export const InnerWrapper = styled.div`
  border: 1px solid var(--pd-secondary-color-light);
  border-radius: 16px;
  padding: 1rem;
  position: relative;
  > *:first-child {
    margin-bottom: 1rem;
    word-break: break-word;
  }
  background-color: #fff;
  position: relative;
  ${(props) =>
    props.highlighted &&
    css`
      animation: 0.5s ease-in 0.3s 1 normal highlightBox;
      @keyframes highlightBox {
        from {
          background-color: #fff;
        }
        50% {
          background-color: var(--pd-primary-color-light);
        }
        to {
          background-color: #fff;
        }
      }
    `}
  overflow-y: auto;
  overflow-x: hidden;
  ${ScrollbarSnippet}
`;

export const CloseButtonWrapper = styled.div`
  position: absolute;
  right: 0.5rem;
  top: -1.3rem;
`;
